import { ClientEvent, Room } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { matrixClient } from '../../client';
import { matrixRoom } from '../../room';
import { RoomMembership } from '../types';

const fileLogger = new Log(false, 'im.client.room.handlers.room');
fileLogger.childrenPaused = true;

function onClientNewRoom(room: Room) {
    const logger = fileLogger.sub(false, 'onClientNewRoom');
    logger.pause = true;
    const membership = room.getMyMembership();
    logger.log(`Room event: ${room.roomId}, membership: ${membership}`);
    
    // 如果是加入房间，则获取成员列表
    if (membership === 'join') {
        // 获取房间成员
        const members = room.getMembers();
        logger.log(`Found ${members.length} members in room ${room.roomId}`);

        // 更新房间成员列表
        matrixRoom.roomData.roomMembers[room.roomId] = members.map(member => ({
            userId: member.userId || '',
            displayName: member.name || '',
            avatarUrl: member.getAvatarUrl(
                matrixClient.client.baseUrl,
                96, // width
                96, // height
                'crop',
                true, // allowDefault
                true // useHttps
            ) || '',
            membership: (member.membership || 'leave') as RoomMembership
        }));
    }
}

export const roomHandler = {
    init() {
        matrixClient.clientOnEventDispatcher.addListener(ClientEvent.Room, onClientNewRoom);
    }
};